<template>
  <b-row>
    <b-col lg="12" class="col-mg-bt">
      <p>
        <strong>INSTRUCCIONES:</strong>
      </p>
      <p class="pre-formatted">{{data.instrucciones}}</p>
    </b-col>

    <b-col lg="12" class="col-mg-bt">
      <p>
        <strong>OPCIONES A ELEGIR:</strong>
      </p>
      <span
        class="options-drag elemento-origen"
        v-for="(f,index) in frases"
        :key="index"
        :id="`option${f.index}${data.id}`"
        draggable="true"
        @dragstart="drag($event)"
        @dragover.prevent
        @drop="drop($event)"
      >{{f.texto}}</span>
    </b-col>

    <b-col lg="12" class="col-mg-bt">
      <p>
        <strong>LECTURA A COMPLETAR:</strong>
      </p>
      <drag-drop-div v-for="(d,index) in lecturaArry" :index="index" :data-id="data.id" :value="d" :key="index"></drag-drop-div>
    </b-col>

    <b-col cols="12">
      <b-button
        style="float: right; margin: 10px"
        variant="primary"
        @click="verificarResultados"
      >Verificar Resultados</b-button>
    </b-col>


    
  </b-row>
</template>
<style lang="scss">
.pre-quiz-activity {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #ceebf0;
  border-radius: 0.5rem;
  padding-top: 10px;
  padding-bottom: 10px;
}
.pre-formatted {
  white-space: pre;
}
.options-drag {
  height: auto;
  border: 1px solid #aaaaaa;
  border-radius: 1%;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  align-self: center;
  padding: 5px;
  margin: 5px;
  cursor: grab;
}
.col-mg-bt {
  margin-bottom: 20px;
}
.ele-display-none {
  display: none !important;
}
.correcta {
    border: .2rem solid green;
}
.incorrecta {
    border: .2rem solid red;
}

//TODO: verificar los cuadros de carga como sus vistaS
</style>
<script>
function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

import DragDropDiv from "@/components/DragDropDiv";

export default {
  name: "pre-completar-frase",
  data() {
    return {
      frases: [],
      textoPrev: "",
      lecturaArry: [],
      frasesToCheck: []
    };
  },
  components: {
    DragDropDiv
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "CompletarFrase",
          instrucciones: "",
          lectura: ""
        };
      }
    }
  },
  created() {
    this.textoPrev = this.data.lectura;
    var items = [];
    this.data.lectura.match(/\[([^\]\[]+)\]/g).forEach((item, index) => {
      items.push(item);
      let txt = item.replace(/[\[\]]/g, "");
      let itemData = { texto: txt, index: index };
      this.frases.push(itemData);
      this.frasesToCheck.push(itemData);
    });

    var newText = this.data.lectura;
    items.forEach(el => {
      newText = newText.replace(el, "");
    });

    var arryOk = [];
    var arry = newText.split(" ");
    var index = 0;
    arry.forEach(el => {
      if (el == "") {
        var data = { texto: null, index: index };
        index++;
      } else {
        var data = { texto: el, index: false };
      }
      arryOk.push(data);
    });

    this.lecturaArry = arryOk;
    console.log(arryOk);    

    //this.data.lectura.replace(/[^0-9\.]+/g,'');
    this.frases = shuffle(this.frases);
    console.log(this.frases);
  },
  methods: {
    drag(event) {
      //console.log(event);
      event.dataTransfer.setData("id", event.target.id);
      event.dataTransfer.setData("value", event.target.innerHTML);
    },
    drop(ev) {      
      let idOrigen = ev.dataTransfer.getData("id");
      let dataOrigen = ev.dataTransfer.getData("value");
      let elementoOrigen = document.getElementById(idOrigen);
      let idDestino = ev.target.id;
      let elementoDestino = document.getElementById(idDestino);
      let dataDestino = elementoDestino.innerHTML;
      elementoOrigen.innerHTML = dataDestino;
      elementoDestino.innerHTML = dataOrigen;
    },
    verificarResultados() {
      let matchesArry = [];
      let aciertos = 0;
      let allElements = document.getElementsByClassName(this.data.id);
      for (let i = 0; i < allElements.length; i++) {
        matchesArry.push(allElements[i].innerHTML);
      }

      this.frasesToCheck.forEach((el, index) => {
        if (el.texto == matchesArry[index]) {
          allElements[index].className = "dv-line elementosToMatch "+this.data.id+" correcta";
          aciertos++;
        } else {
          allElements[index].className = "dv-line elementosToMatch "+this.data.id+" incorrecta";
        }
      });

      let promedio = (100 * aciertos) / matchesArry.length;

      if (promedio >= 70) {
        this.$swal({
          type: "success",
          title: "¡EN HORA BUENA!",
          text: `Tu promedio de aciertos en esta actividad es del ${Math.round(promedio)}%`,
          showCancelButton: false,
          confirmButtonColor: "#285c4d",
          confirmButtonText: "Aceptar"
        }).then(result => {
          if (result.value) {
          }
        });
      } else {
        this.$swal({
          type: "warning",
          title: "¡PROMEDIO BAJO!",
          text: `Tu promedio de aciertos en esta actividad es del ${Math.round(promedio)}%`,
          showCancelButton: false,
          confirmButtonColor: "#285c4d",
          confirmButtonText: "Aceptar"
        }).then(result => {
          if (result.value) {
          }
        });
      }

      console.log(matchesArry);

      console.log(this.frasesToCheck);
    }
  }
};
</script>